import { GET } from "./index";

export function fetchData() {
  return GET("/projects");
}
